import { InputText } from "primereact/inputtext";
import { useCallback, useState } from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { classNames } from "primereact/utils";
import { useAppContext } from "../../providers/ProviderAppContainer";
import { useDispatch } from "react-redux";
import { updateCurrentUser } from "../../redux/sliceUser";
import { APP_NAME, REGEX_EMAIL } from "../../constants";

export default function AskEmail({ id }) {
    const { requestAPI, showToast } = useAppContext();

    const [email, setEmail] = useState();
    const [loading, setLoading] = useState();

    const dispatch = useDispatch();

    const updateEmail = useCallback(() => {
        const trimmed = String(email || "").trim().toLowerCase();
        if (!REGEX_EMAIL.test(trimmed)) {
            showToast({ severity: "error", summary: "Failed", detail: "Enter a valid email address !", life: 2000 });
            return;
        }
        requestAPI({
            requestPath: `users/email`,
            requestMethod: "PATCH",
            requestPostBody: { id, email: trimmed },
            setLoading: setLoading,
            onRequestFailure: () => showToast({ severity: "error", summary: "Failed", detail: "Failed To Update Email !", life: 2000 }),
            onResponseReceieved: (updatedUser, responseCode) => {
                if (responseCode === 200) {
                    showToast({
                        severity: "success",
                        summary: "Updated",
                        detail: `Email Updated`,
                        life: 1000,
                    });
                    dispatch(updateCurrentUser(updatedUser));
                } else {
                    const detail =
                        typeof updatedUser?.error === "string" ? updatedUser.error : "Failed To Update Email !";
                    showToast({ severity: "error", summary: "Failed", detail, life: 2000 });
                }
            },
        });
    }, [dispatch, email, id, requestAPI, showToast]);

    return (
        <Card
            title="Add Your Email"
            subTitle="Critical Information Missing"
            header={<img alt="Card" src="https://primefaces.org/cdn/primereact/images/usercard.png" />}
            className="m-2"
            pt={{ content: classNames("text-right") }}
        >
            <p className="text-sm line-height-3">
                In Order To Continue With {APP_NAME} App - User is Required To Submit An Email Address. {APP_NAME} Respect The Privacy &
                Stores The Details For Internal Usage To Make User Expereice Better !
            </p>

            <Divider />

            <div className="p-inputgroup ">
                <span className="p-inputgroup-addon">
                    <i className="pi pi-envelope"></i>
                </span>
                <InputText
                    value={email || ""}
                    id="email"
                    className="w-full"
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                />
            </div>

            <Button loading={loading} className="mt-3" label="Save" icon="pi pi-check" severity="warning" onClick={updateEmail} />
        </Card>
    );
}
